<template>
    <div class="spinner" :style="{ height: size + 'px', width: size + 'px', 'border-width': borderWidth + 'px', 'border-color': color }"></div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class TDSSpinner extends Vue {
    @Prop({type: Number, default: 16}) size!: number;
    @Prop({type: Number, default: 2}) borderWidth!: number;
    @Prop({type: String, default: ""}) color!: string;
}
</script>

<style scoped lang="scss">
    @keyframes rotate {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(-360deg);
        }
    }

    @keyframes size-in {
        0% {
            width: 0;
            border-width: 0;
        }
        100% {
            border-width: 0;
        }
    }

    @keyframes fade-in {
        0% {
            opacity: 0.3;
        }
        100% {
            opacity: 1.0;
        }
    }

    .spinner {
        display: inline-block;
        margin: 0 auto;
        border: solid 2px white;
        border-radius: 50%;
        border-bottom-color: transparent !important;
        animation: rotate 1.5s infinite linear, size-in 0.15s, fade-in 0.25s;
        animation-delay: 0.15s, 0s, 0.1s;
        vertical-align: baseline;
        box-sizing: border-box;
    }
</style>
